import { memo, type RefObject } from 'react';

import { SettingOptionsLayout } from 'app/modules/wallforming/components/setting-container/SettingOptionsLayout';

import type { CopilotChatLayoutProps } from 'app/modules/wallforming/components/copilot/types/copilotTypes';
import type { Model } from 'flexlayout-react';

interface SettingContainerProps {
    settingModelRef?: RefObject<Model | null>;
    copilotLayout: CopilotChatLayoutProps;
}

export const SettingContainer = memo(
    ({
        settingModelRef,
        copilotLayout: {
            floatingBounds,
            isFloating,
            isOpen,
            onClose: handleClose,
            onDock: handleDock,
            onFloatingBoundsChange: handleFloatingBoundsChange,
            onPopOut: handlePopOut
        }
    }: SettingContainerProps) => (
        <div className="flex h-full min-h-0 w-full min-w-0 flex-row">
            <SettingOptionsLayout
                copilotFloatingBounds={floatingBounds}
                isCopilotFloating={isFloating}
                isCopilotOpen={isOpen}
                settingModelRef={settingModelRef}
                onCopilotClose={handleClose}
                onCopilotDock={handleDock}
                onCopilotFloatingBoundsChange={handleFloatingBoundsChange}
                onCopilotPopOut={handlePopOut}
            />
        </div>
    )
);

SettingContainer.displayName = 'SettingContainer';
